'use client';
import OneTrustCookie from '@/components/OneTrustCookie';
import { browserIsInApp } from '@/utils';
import { loginUser } from '@/utils/cookie';
import gtm from '@/utils/gtm';
import { amazonDSPScript, lineTagScript, linkedinScript, loadJPScript, LoadTriplePixel, loadUSScript, loadYahooScript, loadZAScript } from '@/utils/scriptFnc';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { addScriptAHandle } from './scripts/addScriptA';
// 是否不是app的某个页面
const isNotAppThePageFn = (isApp: boolean, pathname: string) => {
    const allowPathname = ['/delta-pro-3-portable-power-station'];
    if (isApp && allowPathname.includes(pathname)) {
        return false;
    }
    return true;
};
const isCypressTestFn = () => {
    if (typeof window !== 'undefined') {
        const userAgent = window?.navigator?.userAgent || '';
        const devices = userAgent.toLowerCase() || '';
        if (devices.indexOf('iscypresstest') > 0) {
            return true;
        }
    }
    return false;
};
const gaTimerNumberA = 20 * 1000; //多少秒后初始化GA 11
const NEXT_PUBLIC_MODY = process.env.NEXT_PUBLIC_MODY;
const NEXT_IS_PRD = NEXT_PUBLIC_MODY === 'prd' || NEXT_PUBLIC_MODY === 'staging' || NEXT_PUBLIC_MODY === 'uat';
const openOneTrustCookie = process.env.NEXT_PUBLIC_ONETRUST_OPEN === 'on';
const releaseWhiteList = ['release-test-cloud.ecoflow.com', 'release-test.ecoflow.com'];

export default function GAGlobal() {
    const router = useRouter();
    const { locale = 'us', pathname, asPath = '' } = router;
    const has_utm_campaign = asPath.includes('utm_campaign='); //广告参数
    const isApp = typeof window === 'undefined' ? false : browserIsInApp(navigator.userAgent, null);
    const hasInitFlag = useRef(false); //用于只执行1次
    // 是否是自动化脚本
    const isCypressTest = isCypressTestFn();
    const [showCookie, setShowCookie] = useState(false);
    const gaTimerA = useRef<any>(null); //GA倒计时进入
    let OneTrustCookieCN: any = null;
    if (locale === 'cn') {
        OneTrustCookieCN = dynamic(() => import('@/components/OneTrustCookie/CN'), {
            ssr: true,
        });
    }

    const reqListener = function () {
        window.dataLayer = window.dataLayer || [];
        const data = JSON.parse(this.responseText);
        const TDID = data && data.TDID;
        if (TDID) {
            dataLayer.push({ event: 'get-tdid', tdd: data });
        }
    };

    const reqDEListener = function () {
        window.dataLayer = window.dataLayer || [];
        const data = JSON.parse(this.responseText);
        const TDID = data && data.TDID;
        if (TDID) {
            dataLayer.push({ event: 'get_tdid', tdid: TDID });
        }
    };
    const loadUSRequest = () => {
        // US 品牌站TTD广告代码更新
        const oReq: any = new XMLHttpRequest();
        oReq.withCredentials = true;
        oReq.onload = reqListener;
        oReq.defer = true;
        oReq.strategy = 'lazyOnload';
        oReq.open('get', 'https://match.adsrvr.org/track/rid?v=1.0.0&ttd_pid=v2k1fau&fmt=json', true);
        oReq.send();
    };

    const loadDERequest = () => {
        // US 品牌站TTD广告代码更新
        const oReq: any = new XMLHttpRequest();
        oReq.withCredentials = true;
        oReq.onload = reqDEListener;
        oReq.defer = true;
        oReq.strategy = 'lazyOnload';
        oReq.open('get', 'https://match.adsrvr.org/track/rid?v=1.0.0&ttd_pid=v2k1fau&fmt=json', true);
        oReq.send();
    };

    const yahooInit = () => {
        window.yjDataLayer = window.yjDataLayer || [];
        function ytag() {
            yjDataLayer.push(arguments);
        }
        ytag({ type: 'ycl_cookie' });
        ytag({
            type: 'yjad_retargeting',
            config: {
                yahoo_retargeting_id: 'KL02JK87VH',
                yahoo_retargeting_label: '',
                yahoo_retargeting_page_type: '',
                yahoo_retargeting_items: [{ item_id: '', category_id: '', price: '', quantity: '' }],
            },
        });
    };

    // cookie授权回调函数
    const OptanonWrapper = () => {
        // 各站点按需统计，提前return
        setTimeout(() => {
            const localeStatis = () => {
                // loadSchemaScript();
                // 中国站点专用统计
                if (locale === 'cn') {
                    gtm.initBd();
                    return;
                }

                // 日本站点专用统计
                loadJPScript(locale);

                // 南非品牌官网TTD pixel安装
                loadZAScript(locale);

                loadUSScript(locale);

                // 亚马逊DSP广告代码安装需求
                amazonDSPScript();

                // Triple Whale Pixel 代码安装需求 NA
                LoadTriplePixel(locale);

                // B端销售销售RE-MKT广告代码设置需求
                linkedinScript();

                if (locale === 'jp') {
                    // 使用LINE Tag追蹤
                    lineTagScript();
                    // yahoo广告代码
                    loadYahooScript();
                }
                if (locale === 'de') {
                    addScriptAHandle();
                }
                // de/fr Clarity 在用户同意 cookie 后才加载
                const clarityKeyMap: Record<string, string> = {
                    de: 'imrwcicxpk',
                    fr: 'imrwra1rf7',
                    es: 'imrx9ecre6',
                    eu: 'imrxhd018z',
                };
                if (clarityKeyMap[locale]) {
                    (function (c: any, l: any, a: any, r: any, i: any, t: any, y: any) {
                        c[a] =
                            c[a] ||
                            function () {
                                (c[a].q = c[a].q || []).push(arguments);
                            };
                        t = l.createElement(r);
                        t.async = 1;
                        t.src = 'https://www.clarity.ms/tag/' + i;
                        y = l.getElementsByTagName(r)[0];
                        y.parentNode.insertBefore(t, y);
                    })(window, document, 'clarity', 'script', clarityKeyMap[locale], null, null);
                }
            };
            localeStatis();
        }, 500);

        // 埋点统一处理
        setTimeout(() => {
            // 用户埋点
            if (window?.ptengine?.identify) {
                const { user } = loginUser() || { user: {} };
                window.ptengine.identify(user?.id, {
                    email: user?.email || 'N/A',
                    name: user?.name || 'N/A',
                    last_order: user?.last_order || 'N/A',
                    orders_count: user?.orders_count || 'N/A',
                    total_spent: user?.total_spent || 'N/A',
                });
            }
            if (locale === 'cn') {
                return;
            }
            // gtm埋点初始化（含pushPageView）
            gtm.init();
            // if (locale === 'us') {
            //     loadUSRequest();
            // }
            // if (locale === 'de') {
            //     loadDERequest();
            // }
            // yahoo广告代码
            if (locale === 'jp') {
                yahooInit();
            }
            // B端销售销售RE-MKT广告代码设置需求
            const _linkedin_partner_id = '3771650';
            window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
            window._linkedin_data_partner_ids.push(_linkedin_partner_id);
            EcoDesignEventsBus.emit('GtmPageLoad-start');
        }, 700);
    };
    const initGAHandle = () => {
        if (hasInitFlag.current) {
            return;
        }
        hasInitFlag.current = true; //执行了
        cancelEventHandle(); //取消事件
        if (
            isCypressTest ||
            pathname.indexOf('/tempedit') > -1 ||
            pathname.indexOf('/devtest1') > -1 ||
            pathname.indexOf('/devtest2') > -1 ||
            pathname.indexOf('/temppreview') > -1 ||
            pathname.indexOf('/edit-blog') > -1 ||
            pathname.indexOf('/blog-details-preview') > -1 ||
            pathname.indexOf('/blog-preview') > -1 ||
            pathname.indexOf('/withdrawal-request') > -1 ||
            pathname.indexOf('/airwallex-create-bank') > -1
        ) {
            return null;
        }

        // https://ecoflow.feishu.cn/docx/OcosdoRfco7gngxYSUfcEQivnGc
        if (['de', 'fr', 'it', 'eu', 'es', 'uk'].includes(locale)) {
            // Define dataLayer and the gtag function.
            window.dataLayer = window.dataLayer || [];
            function gtag() {
                dataLayer.push(arguments);
            }
            // Default ad_storage to 'denied'.
            gtag('consent', 'default', {
                ad_storage: 'denied',
                analytics_storage: 'denied',
                ad_personalization: 'denied',
                ad_user_data: 'denied',
                wait_for_update: 500,
            });
        }

        // 部分测试环境放开加载gtm
        const IS_RELEASE_TEST = typeof window !== 'undefined' && releaseWhiteList.includes(window.location.hostname);
        if (NEXT_IS_PRD || IS_RELEASE_TEST) {
            window.OptanonWrapper = OptanonWrapper;

            // de/fr 使用 consentmanager autoblocking，必须等脚本加载完再执行
            // OptanonWrapper 由 OneTrustCookie 的 handleLoad 回调触发
            const isConsentManager = ['de', 'fr'].includes(locale);
            if (!isConsentManager) {
                setTimeout(() => {
                    const isNotAppThePageFlag = isNotAppThePageFn(isApp, pathname);
                    isNotAppThePageFlag && OptanonWrapper();
                }, 200);
            }
        }
    };

    // 取消事件-所有
    const cancelEventHandle = () => {
        try {
            window.removeEventListener('scroll', addEventHandleScroll);
            document.body.removeEventListener('click', documentClickHandle);
            clearTimeout(gaTimerA.current);
        } catch (error) {}
    };

    // 绑定事件-滚动
    const addEventHandleScroll = () => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop < 50) {
            return;
        }
        // 要执行的事件
        initGAHandle();
    };
    // 绑定事件-点击
    const documentClickHandle = () => {
        // 要执行的事件
        initGAHandle();
    };
    // 用户没有任何行为,多少秒后执行倒计时
    const gATimerHandle = () => {
        gaTimerA.current = setTimeout(() => {
            // 要执行的事件
            initGAHandle();
        }, gaTimerNumberA);
    };
    useEffect(() => {
        // 执行用户动作后执行
        const bindUserActionHandle = () => {
            setTimeout(() => {
                setShowCookie(true);
            }, 100);
            if (has_utm_campaign) {
                //带了广告参数
                setTimeout(() => {
                    initGAHandle();
                }, 800);
            } else {
                //不带广告参数
                window.addEventListener('scroll', addEventHandleScroll);
                document.body.addEventListener('click', documentClickHandle);
                gATimerHandle();
            }
        };
        bindUserActionHandle();
    }, []);
    return (
        <>
            {showCookie && <OneTrustCookie locale={locale} handleLoad={['de', 'fr'].includes(locale) ? OptanonWrapper : gATimerHandle} />}
            {openOneTrustCookie && showCookie && locale === 'cn' && OneTrustCookieCN && <OneTrustCookieCN locale={locale} />}
        </>
    );
}
